interface RetryOptions {
  retries: number;
  delayMs: number;
}

function wait(delayMs: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, delayMs));
}

export async function retry<T>(operation: () => Promise<T>, options: RetryOptions): Promise<T> {
  let lastError: unknown;

  for (let attempt = 0; attempt <= options.retries; attempt += 1) {
    try {
      return await operation();
    } catch (error) {
      lastError = error;
      if (attempt === options.retries) {
        throw error;
      }
      await wait(options.delayMs);
    }
  }

  throw lastError instanceof Error ? lastError : new Error('Retry failed');
}
